import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

@Injectable()
export class PublicResolve implements Resolve<any> {
  constructor(private authService: AuthService) {}

  resolve(route: ActivatedRouteSnapshot) {
    let sessionResolve = this.authService.checkSession();
    return merge(sessionResolve);
  }
}
